// Réponse standard du backend
export interface BackendResponse<T> {
  status: string | number;
  content: T;
  token: string | null;
  backStatus: string;
  message?: string;
  error?: string;
}

// Réponse spécifique pour la liste des bouteilles
export interface BottlesListResponse {
  userName: string;
  status: string;
  bouteilles: BackendBouteille[];
}

// Modèle Bouteille tel que retourné par le backend
export interface BackendBouteille {
  bouteilleId: number;
  dateCreation: number; // Timestamp
  dateModification?: number;
  dateSuppression?: number;
  status: 'ACTIVE' | 'ARCHIVE';
  description?: string;
  reference: string;
  bouteilleUserId: number;
  picture?: string; // URL S3
  annee?: string;
  name: string;
  type: number; // 1-5
  occasion: number;
  note: number; // 0-5
  share: string; // "true"/"false"
  dateBu?: number; // Date archivage timestamp
  commentaire?: string; // Commentaire archivage
}

// DTO pour créer/modifier une bouteille
export interface BouteilleDTO {
  bouteilleId?: number;
  reference?: string;
  name?: string;
  type?: number;
  annee?: string;
  description?: string;
  note?: number;
  occasion?: number;
  share?: string;
  commentaire?: string;
}

// Mapping des types de bouteilles backend → frontend
export const BOTTLE_TYPE_MAPPING: Record<number, string> = {
  1: 'RED',
  2: 'WHITE',
  3: 'ROSE',
  4: 'CHAMPAGNE',
  5: 'SPIRITS'
};

// Mapping inverse frontend → backend
export const BOTTLE_TYPE_REVERSE_MAPPING: Record<string, number> = {
  'RED': 1,
  'WHITE': 2,
  'ROSE': 3,
  'CHAMPAGNE': 4,
  'SPIRITS': 5
};